import { ApolloError, type ServerError } from '@apollo/client'
import { type GraphQLError, type GraphQLErrorExtensions } from 'graphql'
import { logError } from 'logService'
import { toast } from 'react-toastify'

import { type ErrorCode } from '@/types/graphql'

import translate from './translate'

/**
 *
 * @param error
 * @param context Represent the component where you are handling this error.
 * @returns
 */
export default function apolloErrorHandler(error: unknown, context: string) {

  const fallback = 'Une erreur est survenue'

  if (!(error instanceof ApolloError)) {
    return fallback
  }

  const errors = [
    ...error.graphQLErrors,
    ...(((error.networkError as ServerError | null)?.result as
    | { errors?: GraphQLError[] }
    | undefined)?.errors ?? []),
  ]

  if (errors.length === 0) {
    toast.error('Une erreur générique est survenue', {
      position: 'top-center',
    })
    return
  }

  const errorExtensions = errors[0].extensions
  const errorCode = errorExtensions?.code as ErrorCode
  const extensions = (errorExtensions?.params ?? {}) as GraphQLErrorExtensions

  const message = translate(errorCode, extensions)

  toast.error(message, {
    position: 'top-center',
  })

  logError('GRAPHQL', context, error)
}
